

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const rp241 = {
    label: "Customer Form 15G/From 15H Register",
    pageLabel: "Customer Form 15G/From 15H Register",
    starting: true,
    url: "rp241",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Parent Branch",
            name: "",
            description: "Enter Parent Branch" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Parent Branch",
            name: "ParentBranch",
            description: "Parent Branch"
          }, 
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
           {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Detail",
            name: "Detail",
            description: "Detail"
          } ,
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product",
            label: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product Group",
            label: "Product Group",
            name: "Producgroup",
            description: "Enter Product Group"
          },
          {
            inputType: "select",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options:[
                {
                    label:"Loan",
                    value:"Loan"
                },
                {
                    label:"Deposit",
                    value:"Deposit"
                },
                {
                    label:"Bank",
                    value:"Bank"
                },
                {
                    label:"Other",
                    value:"Other"
                }
            ],
            placeHolder: "Product Group",
            label: "",
            name: "Producgroup",
            description: "Enter Product Group"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },         
          
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product Type",
            label: "Product Type",
            name: "Producttype",
            description: "Enter Product Type"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product Product Type",
            name: "Producttype",
            description: "Enter Product Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "As on Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "dateFrom",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "dateTo",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Customer Number From To",
            name: "",
            description: "Enter Customer Number From To" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Customer NumberFrom",
            name: "CustomerNumberFrom",
            description: "Enter Customer Number From"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Customer Number To",
            name: "CustomerNumberTo",
            description: "Enter Customer Number To"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          }, 
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Amount From-To",
            name: "",
            description: "Enter Amount From-To" 
          }, 
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Amount From",
            name: "AmountFrom",
            description: "Enter AmountFrom"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "AmountTo",
            name: "AmountTo",
            description: "Enter Amount To"
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-6",
               children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Account Type",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "",
            name: "acttype",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          }, 
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Customer Type",
            name: "",
            description: "Enter Customer Type" 
          },        
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Individual",
                value: "Individual"
              },
              {
                label: "Internal",
                value: "Internal"
              },
              {
                label: "Other",
                value: "Other"
              }
             ],
            placeHolder: "Customer Type",
            name: "CustomerType",
            description: "Enter Customer Type"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          }, 
        
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "TDS Flag",
            name: "",
            description: "" 
          },        
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Receipts",
                value: "Receipts"
              },
              {
                label: "Payments",
                value: "Payments"
              },
              {
                label: "Receipts And Payments",
                value: "Receipts And Payments"
              },
              {
                label: "Opening balance Receipts And Payments",
                value: "Opening balance Receipts And Payments"
              },{
                label: "Receipts Payments and Closing balance",
                value: "Receipts Payments and Closing balance"
              },{
                label: "Opening Balance Receipts Payments and Closing balance",
                value: "Opening Balance Receipts Payments and Closing balance"
              },
             ],
            placeHolder: "TDS Flag",
            name: "Receipt_Payment",
            description: "Enter TDS Flag"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Receipts",
                value: "Receipts"
              },
              {
                label: "Payments",
                value: "Payments"
              },
              {
                label: "Receipts And Payments",
                value: "Receipts And Payments"
              },
              {
                label: "Opening balance Receipts And Payments",
                value: "Opening balance Receipts And Payments"
              },{
                label: "Receipts Payments and Closing balance",
                value: "Receipts Payments and Closing balance"
              },{
                label: "Opening Balance Receipts Payments and Closing balance",
                value: "Opening Balance Receipts Payments and Closing balance"
              },
             ],
            placeHolder: "TDS Flag",
            name: "TDSFlag",
            description: "Enter TDS Flag"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter " 
          },
         
          
    ]
}
export default rp241;